import { Component } from '@angular/core';

@Component({
  selector: 'rid-cursor',
  imports: [],
  templateUrl: './rid-cursor.html',
  styleUrl: './rid-cursor.css',
})
export class RidCursor {}
